import { useMachine } from "@xstate/react";
import { Popup } from "devextreme-react";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { Machine } from "xstate";
import { api } from "../../../request/api";
import { AuthenticationResponse } from "../../../Types/AuthenticationResponse";
import { saveAuthentication } from "../../../_helpers/token";
import { InputEx } from "../../Inputs/InputEx";
import { InputLabel } from "../../Labels/InputLabel";
import notify from "devextreme/ui/notify";
import { LoadPanelFullScreen } from "../../LoadPanel/LoadPanelFullScreen";

type Props = {
  login?: string;
};

const fetchMachine = Machine({
  id: "loginForm",
  initial: "idle",
  states: {
    idle: {
      on: {
        FETCH: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      entry: "sigin",
    },
    failure: {
      on: {
        FETCH: "loading",
      },
    },
  },
});

interface IFormInputs {
  login: string;
  password: string;
  newPassword: string;
  newPasswordConfirmed: string;
}

const ChangePasswordForm: React.FC<Props> = (login) => {
  const history = useHistory();
  const { register, getValues, handleSubmit, errors } = useForm<IFormInputs>();
  const [loading, setLoading] = useState<boolean>(false);
  const [state, send] = useMachine(fetchMachine, {
    actions: {
      sigin: () => {
        history.push("/");
      },
    },
  });

  const onSubmit = async (formData: IFormInputs) => {
    send("FETCH");
    setLoading(true);
    try {
      await api
        .post<Response>("User/ChangePassword", {
          Login: login.login,
          Password: formData.password,
          newPassword: formData.newPassword,
          newPasswordConfirmed: formData.newPasswordConfirmed,
        })
        .then((response) => {
          send("RESOLVE");
          notify("Zaloguj się teraz nowymi danymi", "success", 5000);
          setLoading(false);
          history.push("/");
        });
    } catch (err) {
      setLoading(false);
      send("REJECT");
      notify("Stare hasło jest nieprawidłowe", "error", 5000);
    }
  };

  return (
    <>
      <LoadPanelFullScreen visible={loading} />
      <div className="changePasswordForm">
        <div className="cpWrap">
          <div className="mainTitle">Zmiana hasła</div>
          <form onSubmit={handleSubmit(onSubmit)} className="align-self-center">
            <div className="form-group">
              <InputLabel forHtml="password" message="Stare hasło" />
              <InputEx
                className="form-control"
                type="password"
                placeholder=""
                name="password"
                inputRef={register({
                  required: true,
                })}
                aria-describedby="passwordHelp"
              />

              {errors.password?.type === "required" && (
                <small id="passwordHelp" className="form-text text-danger">
                  Hasło jest wymagane.
                </small>
              )}
            </div>

            <div className="form-group">
              <InputLabel forHtml="newPassword" message="Nowe hasło" />
              <InputEx
                className="form-control"
                type="password"
                placeholder=""
                name="newPassword"
                inputRef={register({
                  validate: (value) =>
                    value !== getValues("password") ||
                    "Hasła nie mogą być takie same",
                  required: "Ustawienie nowego hasła jest konieczne.",
                  minLength: {
                    value: 8,
                    message: "Nowe hasło musi mieć co najmniej 8 znaków",
                  },
                  pattern: {
                    value:
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+?&]{8,}$/,
                    message:
                      "Nowe hasło powinno zawierać co najmniej jedną małą literę, dużą literę, znak specjalny oraz cyfrę.",
                  },
                })}
                aria-describedby="newPasswordHelp"
              />

              {errors.newPassword && (
                <small id="newPasswordHelp" className="form-text text-danger">
                  {errors.newPassword.message}
                </small>
              )}
            </div>

            <div className="form-group">
              <InputLabel
                forHtml="newPasswordConfirmed"
                message="Powtórz nowe hasło"
              />
              <InputEx
                className="form-control"
                type="password"
                placeholder=""
                name="newPasswordConfirmed"
                inputRef={register({
                  validate: (value) =>
                    value === getValues("newPassword") ||
                    "Hasła nie są identyczne.",
                  required: "Powtórzenie nowego hasła jest konieczne.",
                })}
                aria-describedby="newPasswordConfirmedHelp"
              />

              {errors.newPasswordConfirmed && (
                <small id="newPasswordHelp" className="form-text text-danger">
                  {errors.newPasswordConfirmed.message}
                </small>
              )}
            </div>

            <InputEx
              type="submit"
              className="btn btnSuccess mt-5"
              value="Zmień"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export { ChangePasswordForm };
